var DualRowPackageWithJOrLLeadData = require('./dualRowPackageWithJOrLLeadData.js');
var lib_core = require("lib-core");

var OscillatorJLeadData = function(position, angle, init) {
    DualRowPackageWithJOrLLeadData.apply(this, arguments);
};

lib_core.inherit(OscillatorJLeadData, DualRowPackageWithJOrLLeadData);
lib_core.JsonParser.registerClass(OscillatorJLeadData, "OscillatorJLeadData");
module.exports = OscillatorJLeadData;
